import type { Component } from "solid-js";
import { For, Match, Switch } from "solid-js";
import { isPlainObject } from "lodash-es";

type GenericValueProps = {
  value: unknown;
  renderComplexData?: boolean;
};
const GenericValue: Component<GenericValueProps> = (props) => (
  <Switch>
    <Match when={["string", "boolean", "number", "bigint"].includes(typeof props.value)}>{String(props.value)}</Match>
    <Match when={(props.renderComplexData ?? true) && Array.isArray(props.value)}>
      <ul>
        <For each={props.value as unknown[]}>
          {(item) => (
            <li>
              <GenericValue value={item} renderComplexData={false} />
            </li>
          )}
        </For>
      </ul>
    </Match>
    <Match when={(props.renderComplexData ?? true) && isPlainObject(props.value)}>
      <ul>
        <For each={Object.entries(props.value as Record<string, unknown>)}>
          {([key, value]) => (
            <li>
              {key} - <GenericValue value={value} renderComplexData={false} />
            </li>
          )}
        </For>
      </ul>
    </Match>
  </Switch>
);

export default GenericValue;
